<template>
    <div class="table_wrap">
        <el-table :data="pointData"
                  class="list-table"
                  header-cell-class-name="list-header"
                  empty-text="데이터가 없습니다."
                  height="695"
        >
            <el-table-column
                class="table_no"
                type="index"
                label="No"
                width="90"
                class-name="num text-center"
                :index="tableIdx"
            >
            </el-table-column>
            <el-table-column width="" label="상품금액" prop="i_price" class-name="text-center">
                <template slot-scope="scope">
                    ￦{{returnCommas(scope.row.i_price)}}
                </template>
            </el-table-column>
            <el-table-column width="" label="충전밍글" prop="ibp_point" class-name="text-center">
                <template slot-scope="scope">
                    {{returnCommas(scope.row.ibp_point)}}M
                </template>
            </el-table-column>
            <el-table-column width="" label="추가밍글" prop="ibp_point_extra" class-name="text-center">
                <template slot-scope="scope">
                    {{returnCommas(scope.row.ibp_point_extra)}}M
                </template>
            </el-table-column>
            <el-table-column
                label="옵션" width="" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info ">
                        <el-button class="com_btn" @click="openModal('product-write-modal',scope.row.ibp_idx)" >수정</el-button>
                        <el-button class="com_del" @click="deleteFunc(scope.row.ibp_idx,scope.row.i_idx)">삭제</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

    </div>

</template>

<script>
import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";
import {paymentType} from "@/service/pointService";
import util from "@/mixins/util";
import commonOptions from "@/mixins/commonOptions";

export default {
  name: "PointListProductLayout",
    mixins: [dateMixins, alertMixins,commonOptions],
  components: {
  },
  inject: ['setPage','setFilter','pointListDelete'],
  provide() {
    return{

    }
  },
  props: {
      pointType: '',
      pointData: {
          default: () => {
              return []
          }
      },
      paginationData: {
          default: () => {
              return {total: 0, page: 0, size: 0,}
          }
      },
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
      returnDate(date = null) {
          if (!date) {
              return '';
          }
          return this.$moment(date).format('YYYY-MM-DD HH:mm')
      },
      tableIdx(index) {
          return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
      },
      returnChargeType(value){
          let keys = Object.keys(paymentType)
          let key = keys.filter(status => Number(status) === value);
          if(util.isEmpty(key)){
              return '-'
          }
          return paymentType[key].name
      },
      returnPoint(pointHistory, point){
          return pointHistory + point;
      },
      returnPlus(point){
          if(point > 0){
              point = "+"+point;
              return point;
          }else{
              return point;
          }
      },
      openModal(name,key) {
          this.$modal.show(name,{'pointKey':key});
      },
      deleteFunc(pointKey,itemKey){
          this.pointListDelete(pointKey,itemKey)
      }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
